import type { ReactElement } from 'react';
import { Box } from '@mantine/core';
import type { ButtonElement } from '@holloway/dsl';

const JUSTIFY = { left: 'flex-start', center: 'center', right: 'flex-end' } as const;

/** Whether a Button element spans the page; elements saved before the setting do. */
export const isFullWidthButton = (element: Pick<ButtonElement, 'buttonAlign'>) =>
  (element.buttonAlign ?? 'full') === 'full';

/**
 * Place a Button element's button per its `buttonAlign`. Shared by the editor
 * canvas and the runner so the two cannot disagree about where a button sits.
 */
export function placeButton(element: Pick<ButtonElement, 'buttonAlign'>, button: ReactElement) {
  if (isFullWidthButton(element)) return button;
  const justifyContent = JUSTIFY[element.buttonAlign as keyof typeof JUSTIFY];
  return <Box style={{ display: 'flex', justifyContent }}>{button}</Box>;
}
